<template>
    <div class="filter">
        <h2 :class="{ invisible: hideHeader }">
            {{ $t('title.search') }}
        </h2>
        <div class="filters">
            <fieldset class="filter-fieldset filterAndButtons">
                <legend class="filter-legend">{{ $t('title.search') }}</legend>
                <div v-if="this.comparisonListFacture !== undefined" class="">
                    <DropDown
                        :display="displayType"
                        :label="$t('label.fournisseur.dropdown.montantttc')"
                        :list="comparisonListFacture"
                        :selectedItem="filter.comparisonFacture"
                        class="width-250px"
                        @select="selectComparisonFacture"
                    />
                </div>
                <div v-if="this.comparisonListFacture !== undefined" class="">
                    <div class="inputWrap noMarginLeft">
                        <NumberInput
                            v-model="filterMontant"
                            :class="filterMontant !== '' ? 'montant' : ''"
                            :label="$t('label.fournisseur.input.montant')"
                            class="filterInput"
                        />
                    </div>
                </div>
                <div v-if="this.siteListTotal !== undefined" class="">
                    <DropDownMultiple
                        :checkboxDisplay="this.siteCheckboxDisplay"
                        :drop-down-bigger="true"
                        :inputDisplay="this.filterSiteDisplay"
                        :isChecked="this.isCheckedSite"
                        :label="$t('label.bySite')"
                        :list="siteList"
                        :listTotal="siteListTotal"
                        :search="searchSite"
                        :selectedItems="filter.siteList"
                        :withSearch="true"
                        class="selectSite"
                        @add="addSelectSite"
                        @multipleSelectSearch="this.multipleSelectSearchSite"
                        @remove="removeSelectSite"
                        @toggleSelectAll="this.toggleSelectAll('site')"
                    />
                </div>
                <div v-if="this.typeInterventionList !== undefined" class="">
                    <DropDown
                        :display="displayType"
                        :label="$t('facture.suivi.dropdown.type.label')"
                        :list="typeInterventionList"
                        :selectedItem="filter.typeIntervention?.libelle"
                        class="width-250px"
                        @select="selectType"
                    />
                </div>
                <div v-if="this.filter.statusList !== undefined" class="">
                    <DropDownMultiple
                        :checkboxDisplay="this.statusCheckboxDisplay"
                        :inputDisplay="this.filterStatusDisplay"
                        :isChecked="this.isCheckedStatus"
                        :label="$t('label.byStatus')"
                        :list="statusList"
                        :listTotal="statusList"
                        :selectedItems="filter.statusList"
                        @add="addSelectStatus"
                        @remove="removeSelectStatus"
                        @toggleSelectAll="this.toggleSelectAll('status')"
                    />
                </div>
                <!--                <div class="" v-if="this.filter.documentTypeList !== undefined">
                    <DropDownMultiple
                        :label="$t('label.byDocumentType')"
                        :list="documentTypeList"
                        :listTotal="documentTypeList"
                        :inputDisplay="this.filterDocumentTypeDisplay"
                        :checkboxDisplay="this.documentTypeCheckboxDisplay"
                        :selectedItems="filter.documentTypeList"
                        :isChecked="this.isCheckedDocumentType"
                        :drop-down-bigger="true"
                        @add="addSelectDocumentType"
                        @remove="removeSelectDocumentType"
                        @toggleSelectAll="this.toggleSelectAll('document')"
                    />
                </div>-->
                <div v-if="this.filter.groupeList !== undefined" class="">
                    <DropDownMultiple
                        :checkboxDisplay="this.groupeCheckboxDisplay"
                        :drop-down-bigger="true"
                        :inputDisplay="this.filterGroupeDisplay"
                        :isChecked="this.isCheckedGroupe"
                        :label="$t('label.byGroupe')"
                        :list="groupeList"
                        :listTotal="groupeList"
                        :selectedItems="filter.groupeList"
                        :disabled="isGroupeDisabled"
                        @add="addSelectGroupe"
                        @remove="removeSelectGroupe"
                        @toggleSelectAll="this.toggleSelectAll('groupe')"
                    />
                </div>
                <div v-if="this.filter.sousGroupeList !== undefined" class="">
                    <DropDownMultiple
                        :checkboxDisplay="this.sousGroupeCheckboxDisplay"
                        :drop-down-bigger="true"
                        :inputDisplay="this.filterSousGroupeDisplay"
                        :isChecked="this.isCheckedSousGroupe"
                        :label="$t('label.bySousGroupe')"
                        :list="sousGroupeList"
                        :list-total="sousGroupeList"
                        :selectedItems="filter.sousGroupeList"
                        :disabled="isSousGroupeDisabled"
                        @add="addSelectSousGroupe"
                        @remove="removeSelectSousGroupe"
                        @toggleSelectAll="this.toggleSelectAll('sousgroupe')"
                    />
                </div>
                <div v-if="this.equipementList !== undefined" class="">
                    <DropDownMultiple
                        :checkboxDisplay="this.equipementCheckboxDisplay"
                        :drop-down-bigger="true"
                        :inputDisplay="this.filterEquipementDisplay"
                        :isChecked="this.isCheckedEquipement"
                        :label="$t('label.byEquipement')"
                        :list="equipementList"
                        :selectedItems="filter.equipementList"
                        :disabled="isEquipementDisabled"
                        @add="addSelectEquipement"
                        @remove="removeSelectEquipement"
                        @toggleSelectAll="this.toggleSelectAll('equipement')"
                    />
                </div>

                <div v-if="filter.interventionId !== undefined" class="inputWrap">
                    <NumberInput
                        v-model="filterInterventionId"
                        :label="$t('label.numIntervention')"
                        class="filterInput"
                    />
                </div>
                <div v-if="filter.demandeInterventionId !== undefined" class="inputWrap">
                    <NumberInput
                        v-model="filterDemandeInterventionId"
                        :label="$t('label.numDemandeIntervention')"
                        class="filterInput"
                    />
                </div>
                <div v-if="filter.demandeDevisId !== undefined" class="inputWrap noMarginLeft">
                    <NumberInput
                        v-model="filterDemandeDevisId"
                        :label="$t('label.numDemandeDevis')"
                        class="filterInput"
                    />
                </div>
                <div v-if="filter.numFactures !== undefined" class="inputWrap">
                    <TextInput v-model="filterNumFactures" :label="$t('label.numFactures')" class="filterInput" />
                </div>
                <div v-if="filter.devisId !== undefined" class="inputWrap">
                    <TextInput v-model="filterDevisId" :label="$t('label.numDevis')" class="filterInput" />
                </div>
                <div v-if="filter.numero !== undefined" class="inputWrap">
                    <TextInput v-model="filterNumero" :label="$t('label.numero')" class="filterInput" />
                </div>
                <div v-if="filter.numeroFacture !== undefined" class="inputWrap">
                    <TextInput v-model="filterNumero" :label="$t('label.filtre.facture')" class="filterInput" />
                </div>
                <div v-if="filter.libelleDoe !== undefined" class="inputWrap">
                    <TextInput v-model="filterLibelleDoe" :label="$t('label.filtre.libelleDoe')" class="filterInput" />
                </div>
                <div v-if="filter.localisationList !== undefined" class="inputWrap">
                    <TextInput v-model="filterLocalisation" :label="$t('label.byLocalisation')" class="filterInput" />
                </div>
                <div v-if="filter.predictedDateFrom !== undefined" class="dateInputWrap">
                    <DatePicker
                        :dateMax="filter.predictedDateTo"
                        :dateValue="filter.predictedDateFrom"
                        :label="$t('label.predictedDateFrom')"
                        @setDate="this.setFilterPredictedDateFrom"
                    />
                </div>
                <div v-if="filter.predictedDateTo !== undefined" class="dateInputWrap">
                    <DatePicker
                        :dateMin="filter.predictedDateFrom"
                        :dateValue="filter.predictedDateTo"
                        :label="$t('label.predictedDateTo')"
                        @setDate="this.setFilterPredictedDateTo"
                    />
                </div>
                <div v-if="filter.createdDateFrom !== undefined" class="dateInputWrap">
                    <DatePicker
                        :dateMax="filter.createdDateTo"
                        :dateValue="filter.createdDateFrom"
                        :label="$t('label.createdDateFrom')"
                        @setDate="this.setFilterCreatedDateFrom"
                    />
                </div>
                <div v-if="filter.createdDateTo !== undefined" class="dateInputWrap">
                    <DatePicker
                        :dateMin="filter.createdDateFrom"
                        :dateValue="filter.createdDateTo"
                        :label="$t('label.createdDateTo')"
                        @setDate="this.setFilterCreatedDateTo"
                    />
                </div>
                <div v-if="filter.factureDateFrom !== undefined" class="dateInputWrap">
                    <DatePicker
                        :dateMax="filter.factureDateTo"
                        :dateValue="filter.createdDateFrom"
                        :label="$t('label.factureDateFrom')"
                        @setDate="this.setFilterCreatedDateFrom"
                    />
                </div>
                <div v-if="filter.factureDateTo !== undefined" class="dateInputWrap">
                    <DatePicker
                        :dateMin="filter.factureDateFrom"
                        :dateValue="filter.createdDateTo"
                        :label="$t('label.factureDateTo')"
                        @setDate="this.setFilterCreatedDateTo"
                    />
                </div>
                <div v-if="filter.documentDateFrom !== undefined" class="dateInputWrap">
                    <DatePicker
                        :dateMax="filter.documentDateTo"
                        :dateValue="filter.documentDateFrom"
                        :label="$t('label.documentDateFrom')"
                        @setDate="this.setFilterDocumentDateFrom"
                    />
                </div>
                <div v-if="filter.documentDateTo !== undefined" class="dateInputWrap">
                    <DatePicker
                        :dateMin="filter.documentDateFrom"
                        :dateValue="filter.documentDateTo"
                        :label="$t('label.documentDateTo')"
                        @setDate="this.setFilterDocumentDateTo"
                    />
                </div>

                <div v-if="filter.devisPubliDateFrom !== undefined" class="dateInputWrap">
                    <DatePicker
                        :dateMax="filter.devisPubliDateTo"
                        :dateValue="filter.devisPubliDateFrom"
                        :label="$t('label.devisPubliDateFrom')"
                        @setDate="this.setFilterDevisPubliDateFrom"
                    />
                </div>
                <div v-if="filter.devisPubliDateTo !== undefined" class="dateInputWrap">
                    <DatePicker
                        :dateMin="filter.devisPubliDateFrom"
                        :dateValue="filter.devisPubliDateTo"
                        :label="$t('label.devisPubliDateTo')"
                        @setDate="this.setFilterDevisPubliDateTo"
                    />
                </div>

                <div v-if="filter.from !== undefined" class="dateInputWrap">
                    <DatePicker
                        :date-max="filter.to"
                        :dateValue="filter.from"
                        :label="$t('label.from')"
                        @setDate="this.setFilterCreatedDateFrom"
                    />
                </div>
                <div v-if="filter.to !== undefined" class="dateInputWrap">
                    <DatePicker :dateValue="filter.to" :label="$t('label.to')" @setDate="this.setFilterCreatedDateTo" />
                </div>
                <CheckBox
                    v-if="filter.isMine !== undefined"
                    :checked="filter.isMine"
                    :label="$t('checkbox.onlyMyRequest')"
                    @clickCheck="toggleCheckMine"
                />
                <div v-if="this.comparisonList !== undefined" class="">
                    <DropDown
                        :display="displayType"
                        :label="$t('facture.suivi.dropdown.montant.label')"
                        :list="comparisonList"
                        :selectedItem="filter.comparison"
                        class="width-250px"
                        @select="selectComparison"
                    />
                </div>
                <div
                    v-if="
                        this.comparisonList !== undefined &&
                        this.filter.comparison !== this.$t('facture.suivi.dropdown.novalue')
                    "
                    class=""
                >
                    <div v-if="filter.interventionId !== undefined" class="inputWrap noMarginLeft">
                        <NumberInput
                            v-model="filterMontant"
                            :class="filterMontant !== '' ? 'montant' : ''"
                            :label="$t('facture.suivi.input.montant')"
                            class="filterInput"
                        />
                    </div>
                </div>
            </fieldset>
            <div v-if="!hideButton" :class="getClassByCritere()">
                <div class="btns">
                    <ButtonWhite :onClick="clearFilter" :text="$t('button.clear')" class="clearBtn" />
                    <ButtonBlue
                        :disabled="disabled && hideButton === undefined"
                        :onClick="search"
                        :text="$t('button.search')"
                        class="searchBtn"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import ButtonBlue from '@/components/ui-components/ButtonBlue.vue';
import ButtonWhite from '@/components/ui-components/ButtonWhite.vue';
import CheckBox from '@/components/ui-components/CheckBox.vue';
import DatePicker from '@/components/ui-components/DatePicker.vue';
import DropDownMultiple from '@/components/ui-components/DropDownMultiple.vue';
import { statusName } from '@/components/ui-components/StatusTag.vue';
import TextInput from '@/components/ui-components/TextInput.vue';
import NumberInput from '@/components/ui-components/NumberInput.vue';
import { Site } from '@/models/Site';
import { defineComponent } from 'vue';
import { TypeDocumentReglementaire } from '@/models/TypeDocumentReglementaire';
import { Groupe } from '@/models/Groupe';
import { EquipementFilter } from '@/models/EquipementFilter';
import DropDown from '@/components/ui-components/DropDown.vue';
import { SousGroupe } from '@/models/SousGroupe';

export default defineComponent({
    name: 'Filter',
    components: { TextInput, ButtonWhite, ButtonBlue, DropDownMultiple, CheckBox, DatePicker, NumberInput, DropDown },
    props: {
        filter: { type: Object, required: true },
        siteList: { type: Array, required: false },
        statusList: { type: Array, required: false },
        documentTypeList: { type: Array, required: false },
        groupeList: { type: Array, required: false },
        sousGroupeList: { type: Array, required: false },
        equipementList: { type: Array, required: false },
        siteListTotal: { type: Array, required: false },
        searchSite: { type: String, required: false },
        hideButton: { type: Boolean, required: false },
        hideHeader: { type: Boolean, required: false },
        comparisonList: { type: Array, required: false },
        comparisonListFacture: { type: Array, required: false },
        typeInterventionList: { type: Array, required: false },
        isGroupeDisabled: { type: Boolean, required: false, default: false },
        isSousGroupeDisabled: { type: Boolean, required: false, default: false },
        isEquipementDisabled: { type: Boolean, required: false, default: false },
    },
    methods: {
        filterSiteDisplay(items: any[], list: any[]): string[] {
            if (items.length === list.length) return [this.$t('all')];
            return items.length > 2 ? [...items.map(x => x.description).slice(0, 2)] : items.map(x => x.description);
        },
        siteCheckboxDisplay(item: Site): string {
            return item.description;
        },
        isCheckedSite(site: Site) {
            return !!this.$props.filter.siteList.find((item: Site) => item.id === site.id);
        },
        isCheckedStatus(status: string) {
            return !!this.$props.filter.statusList.find((item: string) => item === status);
        },
        isCheckedDocumentType(status: string) {
            return !!this.$props.filter.documentTypeList.find((item: string) => item === status);
        },
        isCheckedGroupe(groupe: Groupe) {
            return !!this.$props.filter.groupeList.find((item: Groupe) => item.id === groupe.id);
        },
        isCheckedSousGroupe(sousGroupe: SousGroupe) {
            return !!this.$props.filter.sousGroupeList.find((item: SousGroupe) => item.id === sousGroupe.id);
        },
        isCheckedEquipement(equipement: EquipementFilter) {
            return !!this.$props.filter.equipementList.find((item: EquipementFilter) => item.id === equipement.id);
        },
        filterStatusDisplay(items: string[], list: string[]): string[] {
            if (items.length === list.length) return [this.$t('all')];
            return items.length > 2
                ? [...items.map(x => statusName(x)).slice(0, 2)]
                : items.map(x => {
                      return statusName(x);
                  });
        },
        filterDocumentTypeDisplay(items: TypeDocumentReglementaire[], list: string[]): string[] {
            if (items.length === list.length) return [this.$t('all')];
            return items.length > 2
                ? [...items.map(typeDoc => this.$t(`document.type.${typeDoc.id}`)).slice(0, 2)]
                : items.map(typeDoc => {
                      return this.$t(`document.type.${typeDoc.id}`);
                  });
        },
        filterGroupeDisplay(items: any[], list: any[]): string[] {
            if (items.length === list.length) return [this.$t('all')];
            return items.length > 2 ? [...items.map(x => x.libelle).slice(0, 2)] : items.map(x => x.libelle);
        },
        filterSousGroupeDisplay(items: any[], list: any[]): string[] {
            if (items.length === list.length) return [this.$t('all')];
            return items.length > 2 ? [...items.map(x => x.libelle).slice(0, 2)] : items.map(x => x.libelle);
        },
        filterEquipementDisplay(items: any[], list: any[]): string[] {
            if (items.length === list.length) return [this.$t('all')];
            const formatDisplay = (x: any) => x.phaseLibelle && x.phaseLibelle.trim().toLowerCase() !== 'maintenance' ? `${x.libelle} - ${x.phaseLibelle}` : x.libelle;
            return items.length > 2 ? [...items.map(formatDisplay).slice(0, 2)] : items.map(formatDisplay);
        },
        statusCheckboxDisplay(item: string): string {
            return this.$t(`state.${item}`);
        },
        documentTypeCheckboxDisplay(item: TypeDocumentReglementaire): string {
            if (item.id !== null && item.id < 10) {
                return this.$t(`document.type.${item.id}`);
            } else {
                return item.libelle;
            }
        },
        groupeCheckboxDisplay(item: Groupe): string {
            return item.libelle;
        },
        sousGroupeCheckboxDisplay(item: SousGroupe): string {
            return item.libelle;
        },
        equipementCheckboxDisplay(item: EquipementFilter): string {
            if (item.phaseLibelle && item.phaseLibelle.trim().toLowerCase() !== 'maintenance') {
                return item.libelle + ' - ' + item.phaseLibelle;
            }
            return item.libelle;
        },

        addSelectSite(site: Site): void {
            this.$emit('addFilterSite', site);
        },
        removeSelectSite(site: Site): void {
            this.$emit('removeFilterSite', site);
        },
        addSelectStatus(status: string): void {
            this.$emit('addFilterStatus', status);
        },
        removeSelectStatus(status: string): void {
            this.$emit('removeFilterStatus', status);
        },
        addSelectDocumentType(documentType: TypeDocumentReglementaire): void {
            this.$emit('addFilterDocumentType', documentType);
        },
        removeSelectDocumentType(documentType: TypeDocumentReglementaire): void {
            this.$emit('removeFilterDocumentType', documentType);
        },
        addSelectGroupe(groupe: Groupe): void {
            this.$emit('addFilterGroupe', groupe);
        },
        removeSelectGroupe(groupe: Groupe): void {
            this.$emit('removeFilterGroupe', groupe);
        },
        addSelectSousGroupe(groupe: SousGroupe): void {
            this.$emit('addFilterSousGroupe', groupe);
        },
        removeSelectSousGroupe(groupe: SousGroupe): void {
            this.$emit('removeFilterSousGroupe', groupe);
        },
        addSelectEquipement(equipement: EquipementFilter): void {
            this.$emit('addFilterEquipement', equipement);
        },
        removeSelectEquipement(equipement: EquipementFilter): void {
            this.$emit('removeFilterEquipement', equipement);
        },
        toggleCheckMine(): void {
            this.$emit('setIsMine', !this.$props.filter.isMine);
        },
        clearFilter(): void {
            this.$emit('clearFilter');
        },
        search(): void {
            this.$emit('search');
        },
        toggleSelectAll(type: string) {
            if (type === 'site') {
                this.$emit('siteToggleSelectAll');
            } else if (type === 'status') {
                this.$emit('statusToggleSelectAll');
            } else if (type === 'document') {
                this.$emit('documentTypeToggleSelectAll');
            } else if (type === 'groupe') {
                this.$emit('groupeToggleSelectAll');
            } else if (type === 'sousgroupe') {
                this.$emit('sousGroupeToggleSelectAll');
            } else if (type === 'equipement') {
                this.$emit('equipementToggleSelectAll');
            }
        },
        multipleSelectSearchSite(search: string) {
            this.$emit('multipleSelectSearchSite', search);
        },
        setFilterDevisPubliDateFrom(value: string): void {
            this.$emit('setDevisPubliDateFrom', value);
        },
        setFilterDevisPubliDateTo(value: string): void {
            this.$emit('setDevisPubliDateTo', value);
        },
        setFilterPredictedDateFrom(value: string): void {
            this.$emit('setPredictedDateFrom', value);
        },
        setFilterPredictedDateTo(value: string): void {
            this.$emit('setPredictedDateTo', value);
        },
        setFilterCreatedDateFrom(value: string): void {
            this.$emit('setCreatedDateFrom', value);
        },
        setFilterCreatedDateTo(value: string): void {
            this.$emit('setCreatedDateTo', value);
        },
        setFilterFactureDateFrom(value: string): void {
            this.$emit('setFactureDateFrom', value);
        },
        setFilterFactureDateTo(value: string): void {
            this.$emit('setFactureDateTo', value);
        },
        setFilterDocumentDateFrom(value: string): void {
            this.$emit('setDocumentDateFrom', value);
        },
        setFilterDocumentDateTo(value: string): void {
            this.$emit('setDocumentDateTo', value);
        },
        getClassByCritere(): string {
            return Object.keys(this.filter).length > 4 ? 'btnWrapper adaptive-width' : 'btnWrapper';
        },
        displayType(item: string) {
            return item;
        },
        selectComparison(value: string): void {
            this.$emit('comparison', value);
        },
        selectComparisonFacture(value: string): void {
            this.$emit('comparison', value);
        },
        selectType(value: string): void {
            this.$emit('setType', value);
        },
    },
    computed: {
        disabled(): boolean {
            return (
                this.filter.siteList?.length === 0 ||
                this.filter.statusList?.length === 0 ||
                this.filter.documentTypeList?.length === 0
            );
        },
        filterInterventionId: {
            get(): string {
                return this.$props.filter.interventionId;
            },
            set(value: string): void {
                this.$emit('setInterventionId', value);
            },
        },
        filterDemandeInterventionId: {
            get(): string {
                return this.$props.filter.demandeInterventionId;
            },
            set(value: string): void {
                this.$emit('setDemandeInterventionId', value);
            },
        },
        filterDemandeDevisId: {
            get(): string {
                return this.$props.filter.demandeDevisId;
            },
            set(value: string): void {
                this.$emit('setDemandeDevisId', value);
            },
        },
        filterDevisId: {
            get(): string {
                return this.$props.filter.devisId;
            },
            set(value: string): void {
                this.$emit('setDevisId', value);
            },
        },
        filterNumero: {
            get(): string {
                return this.$props.filter.numero;
            },
            set(value: string): void {
                this.$emit('setNumero', value);
            },
        },
        filterLibelleDoe: {
            get(): string {
                return this.$props.filter.libelleDoe;
            },
            set(value: string): void {
                this.$emit('setLibelleDoe', value);
            },
        },
        filterNumFactures: {
            get(): string {
                return this.$props.filter.numFactures;
            },
            set(value: string): void {
                this.$emit('setNumFactures', value);
            },
        },
        filterLocalisation: {
            get(): string {
                return this.$props.filter.localisationList;
            },
            set(value: string): void {
                this.$emit('setLocalisation', value);
            },
        },
        filterMontant: {
            get(): string {
                return this.$props.filter.comparisonValue;
            },
            set(value: string): void {
                this.$emit('comparisonValue', value);
            },
        },
    },
});
</script>

<style scoped>
.filter {
    padding: 8px 16px;
    background: white;
    border-radius: 6px;
    margin-bottom: 8px;
}

.filterInput {
    height: 48px;
    padding: 0 4px;
}

h2 {
    font-weight: 500;
    font-size: 18px;
    color: var(--color-principal);
    margin: 0 0 12px 0;
}

.filters {
    display: flex;
    justify-content: space-between;
}

.filter-fieldset {
    border: none;
    padding: 0;
    margin: 0;
}

.filter-legend {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}

.filterAndButtons {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-bottom: 8px;
    gap: 8px;
}

.btnWrapper {
    display: flex;
    justify-content: flex-end;
}
@media screen and (max-width: 1631px) {
    .adaptive-width {
        width: 120px;
    }
}

.btns {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 8px;
    gap: 8px;
}

.clearBtn,
.searchBtn {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: 1px solid var(--color-principal);
    border-radius: 4px;
    padding: 10px;
    text-transform: uppercase;
    font-weight: 600;
    max-height: 50px;
}

.clearBtn {
    background-color: white;
    color: var(--color-principal);
}

.searchBtn {
    background-color: var(--color-principal);
    color: white;
    width: 120px;
}

.noMarginLeft {
    margin-left: 0;
}

.inputWrap {
    width: 250px;
}

.dateInputWrap {
    width: 250px;
}

.selectSite {
    width: 300px;
}
.width-250px {
    width: 250px;
}
.montant :deep(input:not(:focus):not(:valid) ~ .label) {
    height: 12px;
    top: -7px;
    font-size: var(--font-size-very-small);
}
.invisible {
    visibility: hidden;
}
</style>
